/* eslint-disable max-len */
import * as questionIds from "../../questions/questionIds";

export const laaWorkerQuestions = [
    {
        id: questionIds.WhatPercentageOfTheTimeDoYouComeIntoContactWithAnimalOrChemicals,
        questionText: "What percentage of the time do you come into contact with animals and chemicals?",
    },
    {
        id: questionIds.WhatTypeOfSubstancesDoYouComeIntoContactWith,
        questionText: "What type of substances do you come into contact with?",
    },
    {
        id: questionIds.DescribeYourMainTasks,
        questionText: "Describe your main tasks",
    },
    {
        id: questionIds.HowLongHaveYouBeenInYourPresentPost,
        questionText: "How long have you been in your present post?",
    },
    {
        id: questionIds.HaveYourEverOrDoYouCurrentlySufferFromNailProblems,
        questionText: "Have you ever, or do you currently, suffer from nail problems?",
    },
    {
        id: questionIds.HaveYourEverOrDoYouCurrentlySufferFromNailProblemsDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.HaveYourEverOrDoYouCurrentlySufferFromInflammationOfYourMucousMembranesAndOrItchinessOfYourNose,
        questionText: "Have you ever, or do you currently, suffer from inflammation of your mucous membranes and / or itchiness of your nose?",
    },
    {
        id: questionIds.HaveYourEverOrDoYouCurrentlySufferFromInflammationOfYourMucousMembranesAndOrItchinessOfYourNoseDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.HaveYouEverOrDoYouCurrentlySufferFromCoughingOrThroatIrritation,
        questionText: "Have you ever, or do you currently, suffer from coughing or throat irritation?",
    },
    {
        id: questionIds.HaveYouEverOrDoYouCurrentlySufferFromCoughingOrThroatIrritationDetails,
        questionText: "Please provide details",
    },
    {
        id: questionIds.DoYouSufferFromAllergiesOrHayFever,
        questionText: "Do you suffer from allergies or hay fever?",
    },
    {
        id: questionIds.DoYouSufferFromAllergiesOrHayFeverWhenDoTheseSymptomsOccur,
        questionText: "When do these symptoms occur?",
    },
    {
        id: questionIds.DoYouSufferFromAPersistentRunnyNoseOtherThanACold,
        questionText: "Do you suffer from a persistent runny nose, other than a cold?",
    },
    {
        id: questionIds.DoYouSufferFromAPersistentRunnyNoseOtherThanAColdWhenDoTheseSymptomsOccur,
        questionText: "When do these symptoms occur?",
    },
    {
        id: questionIds.DoYouSufferFromBoutsOfSneezingOtherThanACold,
        questionText: "Do you suffer from bouts of sneezing, other than a cold?",
    },
    {
        id: questionIds.DoYouSufferFromBoutsOfSneezingOtherThanAColdWhenDoTheseSymptomsOccur,
        questionText: "When do these symptoms occur?",
    },
    {
        id: questionIds.DoYouSufferFromItchySoreOrWateryEyes,
        questionText: "Do you suffer from itchy, sore or watery eyes?",
    },
    {
        id: questionIds.DoYouSufferFromItchySoreOrWateryEyesWhenDoTheseSymptomsOccur,
        questionText: "When do these symptoms occur?",
    },
    {
        id: questionIds.DoYouSufferFromCoughAndPhlegm,
        questionText: "Do you suffer from cough and phlegm?",
    },
    {
        id: questionIds.WhatColour,
        questionText: "What colour?",
    }
];
